export default __webpack_public_path__ + "static/media/dashboard_lecture_1.273b40af.png";